export const environment = {
  app: {
    apiUrl: "https://api.solviing.com",
  },
};
